import {
  FiHome, FiUsers, FiBox, FiKey, FiSettings, FiLock, FiFileText, FiServer, 
  FiList, FiPieChart, FiShield, FiSmartphone, FiCalendar, FiSlash, FiCpu, FiSliders, FiDatabase, FiPackage, FiActivity, FiInbox, FiHelpCircle, FiZap
} from 'react-icons/fi';

export const navigationConfig = [
  { name: 'Dashboard', path: '/', icon: FiHome },
  { name: 'Connect App', path: '/connect-app', icon: FiZap },
  { name: 'Website Forms', path: '/public-forms', icon: FiFileText },
  { name: 'Clients', path: '/clients', icon: FiUsers },
  { name: 'Apps', path: '/apps', icon: FiBox },
  { name: 'API Keys', path: '/api-keys', icon: FiKey },
  { name: 'App Config', path: '/app-config', icon: FiSettings },
  { name: 'Delivery Queue', path: '/queue', icon: FiInbox },
  { name: 'Email Packs', path: '/email-packs', icon: FiPackage },
  { name: 'Security Centre', path: '/security', icon: FiShield },
  { name: 'Deliverability', path: '/deliverability', icon: FiActivity },
  { name: 'Secure API Key Vault', path: '/secure-vault', icon: FiLock },
  { name: 'Templates', path: '/templates', icon: FiFileText },
  { name: 'Providers', path: '/providers', icon: FiServer },
  { name: 'Logs', path: '/logs', icon: FiList },
  { name: 'Usage', path: '/usage', icon: FiPieChart },
  { name: 'Audit', path: '/audit', icon: FiShield },
  { name: 'OTP Settings', path: '/otp-settings', icon: FiSmartphone },
  { name: 'Scheduled Emails', path: '/scheduled', icon: FiCalendar },
  { name: 'Suppression List', path: '/suppression', icon: FiSlash },
  { name: 'AI Assistant', path: '/ai-assistant', icon: FiCpu },
  { name: 'Settings', path: '/settings', icon: FiSliders },
  { name: 'Data Model', path: '/data-model', icon: FiDatabase },
  { name: 'Help & FAQ', path: '/help', icon: FiHelpCircle },
];